import Progress from './Progress';
import ProgressBar from './ProgressBar';
Progress.Bar = ProgressBar;
export default Progress;